import { OrderType } from '@/resource/question/question.type';

const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const alphabets = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
const romans = [
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'XI',
];

export function getSubjectiveOrder(orderType: OrderType, index: number) {
  let order = '';

  switch (orderType) {
    case OrderType.Number:
      order = numbers[index] + ')';
      break;
    case OrderType.Alphabet:
      order = alphabets[index] + ')';
      break;
    case OrderType.Roman:
      order = romans[index] + ')';
      break;
  }

  return order;
}
